module.exports = __webpack_public_path__ + "static/img/Aions_GZ_Mar_4.383fca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_GZ_Mar/Aions_GZ_Mar_4.png
// module id = rY50
// module chunks = 19